// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFileTextOutlinedSvg from "@fishx/icons-svg/es/asn/PFileTextOutlined";
import FishxIcon from '../components/FishxIcon';

var PFileTextOutlined = function PFileTextOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFileTextOutlinedSvg
  }));
};

PFileTextOutlined.displayName = 'PFileTextOutlined';
export default React.forwardRef(PFileTextOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFileTextOutlined.js
// module id = 3401
// module chunks = 0